import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  ClientResponse,
  LoginRequest,
  LoginResponse,
  ProductResponse,
  ProductType,
  RoleResponse,
  User,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";

export const productService = {
  getProducts: async (
    currentPage: number,
    pageSize: number,
    search?: string
  ): Promise<ProductResponse> => {
    const response = await apiClient.get<ApiResponse<ProductResponse>>(
      ENDPOINTS.PRODUCTS.GET_ALL,
      {
        params: {
          page: currentPage,
          rowPerPage: pageSize,
          search: search ?? "",
        },
      }
    );
    return response.data.data;
  },

  /**
   * GET /api/products/GetAllByClientIdAsync — productos del cliente (page, rowPerPage, search, clientId).
   */
  getProductsByClientIdAsync: async (
    page: number,
    rowPerPage: number,
    search: string,
    clientId: string,
  ): Promise<ProductResponse> => {
    const response = await apiClient.get<ApiResponse<ProductResponse>>(
      ENDPOINTS.PRODUCTS.GET_ALL_BY_CLIENT_ID_ASYNC,
      {
        params: {
          page,
          rowPerPage,
          search: search ?? "",
          clientId,
        },
      },
    );
    return response.data.data;
  },

  /**
   * GET /api/products — productos filtrados por tipo (id en `productType`).
   * Opcional `search` para el texto del autocomplete.
   */
  getProductsByProductType: async (
    page: number,
    rowPerPage: number,
    productTypeId: string,
    search: string,
  ): Promise<ProductResponse> => {
    const response = await apiClient.get<ApiResponse<ProductResponse>>(
      ENDPOINTS.PRODUCTS.GET_LIST,
      {
        params: {
          page,
          rowPerPage,
          productType: productTypeId,
          ...(search?.trim() ? { search: search.trim() } : {}),
        },
      },
    );
    return response.data.data;
  },

  /** GET /api/products/GetAllProductType — autocomplete de tipos (page, rowPerPage, search) */
  getAllProductType: async (
    page: number,
    rowPerPage: number,
    search: string,
  ): Promise<ProductType[]> => {
    const response = await apiClient.get<ApiResponse<unknown>>(
      ENDPOINTS.PRODUCTS.GET_ALL_PRODUCT_TYPE,
      {
        params: {
          page,
          rowPerPage,
          search: search ?? "",
        },
      },
    );
    const body = response.data?.data ?? response.data;
    const raw =
      (body as any)?.productTypes ??
      (body as any)?.productTypeResponses ??
      (body as any)?.items ??
      (Array.isArray(body) ? body : []);
    const list = Array.isArray(raw) ? raw : [];
    return list.map((item: any) => ({
      productTypeID:
        item.productTypeID ??
        item.productTypeId ??
        item.id ??
        item,
      name:
        item.name ??
        item.nombre ??
        item.description ??
        String(
          item.productTypeID ?? item.productTypeId ?? item.id ?? item,
        ),
      description: item.description,
    }));
  },

  syncProducts: async (): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.PRODUCTS.SYNC_PRODUCTS,
      {}
    );
    return response.data;
  },
};
